import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

import { ShareLinkFieldType, ShareLinkFormType } from '../../../form/link-config-form.factory';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { uploadImageAssetToS3 } from 'src/common/helpers/file-upload';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import PersonalizatonLogoUpload from './logo-upload';
import { PersonalizationDomainInput } from './domain-input';
import { formatUrl } from 'src/utils/url';
import { useProspectLogo } from 'src/common/hooks/use-prospect-logo.hook';

export const ShareConfigPersonalizationPanel = () => {
  const { setErrorNotification } = useNotificationMessage();
  const { values, setFieldValue } = useFormikContext<ShareLinkFormType>();

  const { fetchProspectLogo, logoUrl, domain, fetching: isFetchingBrand, status } = useProspectLogo();

  useEffect(() => {
    if (status === 'success') {
      setFieldValue('personalization_logo_url', logoUrl);
      setFieldValue('personalization_domain', domain);
    }
  }, [logoUrl, domain, status, setFieldValue]);

  const onFieldChange = (payload: ShareLinkFieldType<unknown>) => {
    setFieldValue(payload.field, payload.value);
  };

  const uploadLogo = async (imageFile: File) => {
    // const imageFile = await dataUrlToFile(logo!, `${uuidv4().replace(/-/g, '').substring(0, 6)}.png`);

    try {
      const response = await uploadImageAssetToS3(imageFile);
      if (!response) throw new Error('Could not upload image');
      const { url } = response;

      setFieldValue('personalization_logo_url', url);
    } catch (error: any) {
      setErrorNotification(error.message);
    }
  };

  const onUrlProcessed = async (url: string) => {
    try {
      const formattedUrl = formatUrl(url);
      const domain = new URL(formattedUrl).hostname;

      await fetchProspectLogo(domain);
    } catch (error: any) {
      setErrorNotification(error.message);
    }
  };

  return (
    <div className='flex flex-col space-y-6'>
      <span className='text-bedrock-p-strong text-bedrock-black'>Add recipient logo</span>

      <div className='text-bedrock-p-small text-bedrock-black mt-1'>
        Enter your recipients domain or upload an image and we’ll insert their logo into this Journey
      </div>

      <div className='flex flex-col space-y-6 mt-4'>
        <PersonalizationDomainInput
          onUrlProcessed={onUrlProcessed}
          isLoading={isFetchingBrand}
          personalizationDomain={values.personalization_domain}
        />
        <PersonalizatonLogoUpload
          onLogoFileUpload={uploadLogo}
          onFieldChange={onFieldChange}
          logoUrl={values.personalization_logo_url}
          isFetchingBrand={isFetchingBrand}
        />
      </div>
    </div>
  );
};
